import type { RouteObject } from 'react-router-dom';

import type { Role } from '@/entities/user';

import { REFUNDS_VIEW_ROLES } from './access';

export const refundsRoutes: RouteObject[] = [
  {
    path: 'refunds',
    lazy: async () => {
      const { RefundsListPage } = await import('./pages/RefundsListPage');
      return { Component: RefundsListPage };
    },
    handle: {
      roles: REFUNDS_VIEW_ROLES as Role[],
      nav: {
        labelKey: 'nav.refunds',
        section: 'operations',
      },
    },
  },
  {
    path: 'refunds/:refundId',
    lazy: async () => {
      const { RefundDetailPage } = await import('./pages/RefundDetailPage');
      return { Component: RefundDetailPage };
    },
    handle: {
      roles: REFUNDS_VIEW_ROLES as Role[],
    },
  },
];
